import React from "react";
import TSTable from "../../common/TSTable";
import { URL_TANK } from "../../constants/urls";
import { TANK_STATUS, TANK_STATUS_TH, } from "../../constants/string";
import { FilePdfOutlined } from '@ant-design/icons';
import _ from "lodash";
import ErrorMessages from "../../common/ErrorMessages";
import { dateToHumanString, formatComma, toFixed } from "../../frameworks/Util";
import { Button, Tooltip } from "antd";
import StorageTankWeightLogModal from "./StorageTankWeightLogModal";
import StorageTankStatusLogModal from "./StorageTankStatusLogModal";
import { PATH } from "../../routes/CustomRoutes";

const StorageTankLotHistoryList = React.forwardRef((props, ref) => {

  const [errorMessage, setErrorMessage] = React.useState(null);
  const [targetWeightLog, setTargetWeightLog] = React.useState(null);
  const [targetStatusLog, setTargetStatusLog] = React.useState(null);
  const tableRef = React.useRef();

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useImperativeHandle(ref, () => ({
    fetch : () => refreshData()
  }));

  const columns = [
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      width: 180,
      render : (value) => <center>{value ? dateToHumanString(value) : '-'}</center>
    },
    {
      title: 'แทงก์',
      dataIndex: 'tank_name',
      key: 'tank_name',
      searcher: true,
      render : (value) => value ? value : '-'
    },
    {
      title: 'Lot No.',
      dataIndex: 'lot_no',
      key: 'lot_no',
      searcher: true,
      render : (value, original) => value ? 
        <>
          {value}
          <Tooltip triger='hover' title='รายละเอียดสต๊อกน้ำยางข้น'>
            <Button type='link' icon={<FilePdfOutlined />} onClick={() => window.open(`${window.origin}${PATH.TANK_SUMMARY}/${original.id}`)}/>
          </Tooltip>
        </> : '-'
    },
    {
      title: 'เกรด',
      dataIndex: 'product_name',
      key: 'product_name',
      render : (value) => value ? value : '-'
    },
    {
      title: 'ความสูง (cm)',
      dataIndex: 'current_height',
      key: 'current_height',
      render : (value) => <center>{value ? value : '-'}</center>
    },
    {
      title: 'น้ำหนัก (Kgs)',
      dataIndex: 'current_weight',
      key: 'current_weight',
      render : (value, original) => <center>{value ? <Tooltip triger='hover' title={"ประวัติเปลี่ยนน้ำหนัก"}><a onClick={() => setTargetWeightLog(original.id)}>{formatComma(toFixed(value, 0))}</a></Tooltip> : '-'}</center>
    },
    {
      title: 'สถานะ',
      dataIndex: 'state', 
      key: 'state',
      render : (value, original) => value ? <Tooltip triger='hover' title={"ประวัติเปลี่ยนสถานะ"}><a onClick={() => setTargetStatusLog(original.id)}>{TANK_STATUS_TH[value]}</a></Tooltip> : '-'
    },
  ]

  return(
    <div>
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TANK.TANK_TRANSACTION}
        params={{state : TANK_STATUS.END}}
      />

      <StorageTankWeightLogModal
        open={targetWeightLog ? true : false}
        target={targetWeightLog}
        onClose={() => 
          setTargetWeightLog(null)
        }
      />  

      <StorageTankStatusLogModal
        open={targetStatusLog ? true : false}
        target={targetStatusLog}
        onClose={() => 
          setTargetStatusLog(null)
        }
        onUpdate={() => {
          setTargetStatusLog(null)
          refreshData();
        }}
      />
    </div>
  )
})

export default StorageTankLotHistoryList;